(function () {
  function fixCartItemLinks() {
    document.querySelectorAll('.rebuy-cart__flyout-item-product-title[href]').forEach(function (titleLink) {
      var item = titleLink.closest('.rebuy-cart__flyout-item');
      if (!item) return;

      var mediaLink = item.querySelector('.rebuy-cart__flyout-item-media a[href]');
      if (mediaLink && mediaLink.getAttribute('href') === titleLink.getAttribute('href') && !mediaLink.hasAttribute('data-a11y-fixed')) {
        mediaLink.setAttribute('data-a11y-fixed', 'true');
        mediaLink.setAttribute('aria-hidden', 'true');
        mediaLink.setAttribute('tabindex', '-1');
      }

      if (titleLink.getAttribute('role') === 'heading') {
        titleLink.removeAttribute('role');
        titleLink.removeAttribute('aria-level');
      }
    });
  }

  var observer = new MutationObserver(fixCartItemLinks);
  observer.observe(document.body, { childList: true, subtree: true });
  fixCartItemLinks();
})();
